import { useState, useEffect, useRef } from 'react';

export const useShown = (initial = true) => {
    const [shown, setShown] = useState(initial);
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        // @ts-ignore
        if (ref.current && !ref.current.contains(event.target)) {
            setShown(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return { ref, shown, setShown };
}